import service from "./service";

function logIn(payload) {
    return service.logIn(payload);
}
  
function logOut(payload) {
    return service.logOut(payload);
}

function getMenus() {
    return service.getMenus();
}

function hasRole(payload) {
    return service.hasRole(payload);
}

/**
 * GetInitAccount
 * @param {string} payload.email
 * @param {string} payload.hash
 */
async function getInitAccount(payload) {
    try {
    const res = await service.getInitAccount(payload);
    return res;
    } catch (error) {
    return null;
    }
}

/**
 * SetActivateAccount
 * @param {string} payload.email
 * @param {string} payload.newHash
 * @param {string} payload.phone
 * @param {string} payload.authKey
 */
async function setActivateAccount(payload) {
    try {
    const res = await service.setActivateAccount(payload);
    return res;
    } catch (error) {
    return null;
    }
}

export default {
    logIn,
    logOut,
    getMenus,
    hasRole,
    getInitAccount,
    setActivateAccount,
};
  